(function ($) {
   $(function () {
      $('.posts-layout > button').each(function () {
         $(this).on('click', function () {
            const $this = $(this);
            const $parent = $this.parent();
            $parent.find('button').removeClass('active');
            $this.addClass('active');

            // Get layout value from button (e.g., data-layout attribute or value)
            const layout = $this.data('layout') || $this.val();

            // Update URL parameter
            const url = new URL(window.location);
            url.searchParams.set('layout', layout);
            window.history.replaceState({}, '', url);
            $this
               .closest('.posts-archive')
               .find('.posts-container')
               .attr('data-layout', layout);
         });
      });

      $('.filter-items .filter-button').on('click', function () {
         const $this = $(this);
         $this.siblings().removeClass('active');
         $this.addClass('active');
         const filter = $this.data('cat');
         const $items = $this
            .closest('.posts-archive')
            .find('.posts-container .post-container');
         updateVisibility(filter, $items);
         updateTaxonomyUrl(filter);
      });
      function updateTaxonomyUrl(filter) {
         const currentUrl = new URL(window.location.href);
         const currentPath = currentUrl.pathname.replace(/\/$/, ''); // remove trailing slash
         const pathSegments = currentPath.split('/').filter(Boolean);

         const languages = ['en', 'sv'];
         const hasLangPrefix = languages.includes(pathSegments[0]);

         let basePath;
         if (hasLangPrefix) {
            basePath = '/' + pathSegments[0] + '/' + pathSegments[1];
         } else {
            basePath = '/' + pathSegments[0];
         }

         let newPath;
         if (filter && filter.length > 0) {
            if (hasLangPrefix) {
               newPath =
                  '/' + pathSegments[0] + '/' + pathSegments[1] + '/' + filter;
            } else {
               newPath = '/' + pathSegments[0] + '/' + filter;
            }
         } else {
            newPath = basePath;
         }

         window.history.replaceState({}, '', newPath);
      }

      function updateVisibility(filter, $items) {
         $items.each(function () {
            const $item = $(this);
            if ($item.data('cat').includes(filter)) {
               $item.addClass('visible');
            } else {
               $item.removeClass('visible');
            }
         });
         const $count = $items.filter('.visible').length;
         $('.posts-count span.count-number').text($count);
         if ($count === 1) {
            $('.posts-count .singular-label').show();
            $('.posts-count .plural-label').hide();
         } else {
            $('.posts-count .singular-label').hide();
            $('.posts-count .plural-label').show();
         }
      }
      // Helper: safely extract filter segment whether there's a lang prefix or not
      function getUrlFilterFromPath(pathname) {
         const segments = pathname.split('/').filter(Boolean);
         const languages = ['en', 'sv'];
         const hasLangPrefix =
            segments.length && languages.includes(segments[0]);
         const filterIndex = hasLangPrefix ? 2 : 1;
         return segments.length > filterIndex ? segments[filterIndex] : '';
      }

      const pathSegments = window.location.pathname.split('/').filter(Boolean);
      if (pathSegments.length > 1) {
         const urlFilter = getUrlFilterFromPath(window.location.pathname);

         if (urlFilter) {
            const $activeButton = $(
               `.filter-items .filter-button[data-cat="${urlFilter}"]`,
            );
            if ($activeButton.length) {
               $activeButton
                  .addClass('active')
                  .siblings()
                  .removeClass('active');
            }
            const $items = $('.posts-archive .posts-container .post-container');
            updateVisibility(urlFilter, $items);
         } else {
            // Default: no filter selected
            const activeFilter =
               $('.filter-items .filter-button.active').data('cat') || '';
            updateVisibility(
               activeFilter,
               $('.posts-archive .posts-container .post-container'),
            );
            updateTaxonomyUrl(activeFilter);
         }
      } else {
         // Default: no filter selected
         const activeFilter =
            $('.filter-items .filter-button.active').data('cat') || '';
         updateVisibility(
            activeFilter,
            $('.posts-archive .posts-container .post-container'),
         );
         updateTaxonomyUrl(activeFilter);
      }
      if ($('.filter-items').length == 0) {
         updateVisibility(
            '',
            $('.posts-archive .posts-container .post-container'),
         );
      } else {
         updateVisibility(
            $('.filter-items .filter-button.active').data('cat'),
            $('.posts-archive .posts-container .post-container'),
         );
      }
      $('.filter-dropdown-button').each(function () {
         const $this = $(this);
         $this.on('click', function () {
            const $parent = $this.closest('.filter-container');
            if ($parent.hasClass('open')) {
               $parent.removeClass('open');
            } else {
               $parent.addClass('open');
            }
         });
      });
   });
})(jQuery);
